import Vue from 'vue';
import Component from 'vue-class-component';
import { appBootstrapService } from '../services/appBootstrapService';

@Component({})
export class AppBootstrapMixin extends Vue {
  public isXsUp = false;
  public isXsDown = false;
  public isXs = false;
  public isSmUp = false;
  public isSmDown = false;
  public isSm = false;
  public isMdUp = false;
  public isMdDown = false;
  public isMd = false;
  public isLgUp = false;
  public isLgDown = false;
  public isLg = false;
  public isXlUp = false;
  public isXlDown = false;
  public isXl = false;
  private resizeCallback: any;

  mounted() {
    this.resizeCallback = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeCallback);
    this.evaluate();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  private onResize() {
    this.evaluate();
  }

  private evaluate() {
    this.isXsDown = appBootstrapService.isXsDown;
    this.isXsUp = appBootstrapService.isXsUp;
    this.isXs = appBootstrapService.isXs;
    this.isSmDown = appBootstrapService.isSmDown;
    this.isSmUp = appBootstrapService.isSmUp;
    this.isSm = appBootstrapService.isSm;
    this.isMdDown = appBootstrapService.isMdDown;
    this.isMdUp = appBootstrapService.isMdUp;
    this.isMd = appBootstrapService.isMd;
    this.isLgDown = appBootstrapService.isLgDown;
    this.isLgUp = appBootstrapService.isLgUp;
    this.isLg = appBootstrapService.isLg;
    this.isXlDown = appBootstrapService.isXlDown;
    this.isXlUp = appBootstrapService.isXlUp;
    this.isXl = appBootstrapService.isXl;
  }
}
